module.exports = __webpack_public_path__ + "static/img/zs5.56528b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qualificationDoc/zs5.png
// module id = 7Pty
// module chunks = 1